/**
 * Reference data constants and helpers extracted from the standalone app.
 * Replaces the SharePoint field map dependency with pure utility functions.
 */
import type { AdjacencyNode, Phase, Status } from '../types/adjacency';

export const PHASES: Phase[] = ['Discovery', 'Definition', 'Feasibility', 'Development', 'Beta', 'Launch', 'Production'];
export const STATUSES: Status[] = ['In Progress', 'On Hold', 'Not Started', 'Proposed/Pending', 'Complete', 'Blocked', 'Completed'];

/** Get all Phase values: known constants + any dynamic values from data. */
export function getAllPhases(nodes: AdjacencyNode[]): Phase[] {
  const known = new Set<string>(PHASES);
  const dynamic = new Set<string>();
  for (const n of nodes) {
    if (n.phase && !known.has(n.phase)) dynamic.add(n.phase);
  }
  return [...PHASES, ...Array.from(dynamic)] as Phase[];
}

/** Get all Status values: known constants + any dynamic values from data. */
export function getAllStatuses(nodes: AdjacencyNode[]): Status[] {
  const known = new Set<string>(STATUSES);
  const dynamic = new Set<string>();
  for (const n of nodes) {
    if (n.status && !known.has(n.status)) dynamic.add(n.status);
  }
  return [...STATUSES, ...Array.from(dynamic)] as Status[];
}
